import { render } from "./goodDetails.vue?vue&type=template&id=2528c12e"
import script from "./goodDetails.vue?vue&type=script&lang=js"
export * from "./goodDetails.vue?vue&type=script&lang=js"
script.render = render

export default script